<section
  [ngClass.lt-sm]="{'layout xs sm':true}"
  [ngClass.lt-md]="{'layout sm':true}"
>
  <div class="mainvisual">
    <div class="title" fxLayout="row" fxLayoutAlign="center center">
      <h1>
        <span>Live</span>
        <span>healthy</span>
        <span>life</span>
      </h1>
    </div>
    <div class="view">
      <div class="view__overlay"></div>
      <swiper
        [autoplay]="{delay: 5000}"
        [effect]="'fade'"
        [centeredSlides]="true"
      >
        <ng-template *ngFor="let slide of slides" swiperSlide>
          <div class="slide" fxLayout="row" fxLayoutAlign="center center">
            <img [src]="'/assets/img/' + slide">
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
</section>
